export default __webpack_public_path__ + "static/media/gallery-4-1.f0604f31.jpg";